module.exports = __webpack_public_path__ + "img/video-sdk.031d8da.png";